// GENERATED by generateConfigTesting.js — do not edit.
// Client id handed to the PayPal JS SDK in CartModal. Switch environments by
// rebuilding: `npm run build-testing` or `npm run build-release`.

export const PAYPAL_CLIENT_ID = "ASDzGW8u7SIlQLlxhzw8Ccym2OnE4tNlDqsP8mFOFjfBoYhnEF-QhzRGVsO55G3GB8KlDZLKVXPa8YYV";
export const PAYPAL_ENV: "live" | "sandbox" = "sandbox";
